import { useTheme } from '../themes/ThemeProvider';
import { useDeviceType } from './useDeviceType';
export function useGrid() {
    const { deviceType } = useDeviceType();
    const theme = useTheme();
    const gridColumns = deviceType === 'mobile'
        ? Number(theme['grid-columns-xxs'])
        : deviceType === 'tablet'
            ? Number(theme['grid-columns-xs'])
            : Number(theme['grid-columns-s']);
    const gridGutter = deviceType === 'mobile'
        ? theme['grid-gutter-xxs']
        : deviceType === 'tablet'
            ? theme['grid-gutter-xs']
            : theme['grid-gutter-s'] || '16px';
    return { gridColumns, gridGutter, deviceType };
}
